import { Trash2 } from 'lucide-react'

import { Campaign } from '@/core/api/entities/campaign/campaign'
import { Group } from '@/core/api/entities/group'
import { useTranslation } from '@/core/i18n/useTranslation'
import { CampaignCard } from '@/shared/components/molecules/CampaignCard/CampaignCard'

interface AdCampaignCardProps {
	campaign: Campaign
	variant?: 'group' | 'zone'
	onRemove?: (id: number) => void
	onClick?: (id: number) => void
	groups?: Group[]
}

export const AdCampaignCard = ({
	campaign,
	onRemove,
	onClick,
}: AdCampaignCardProps) => {
	const { t } = useTranslation('zones')

	const menuItems = onRemove
		? [
				{
					label: t('adCampaignCard.removeCampaign'),
					icon: Trash2,
					onClick: () => onRemove(campaign.id),
					variant: 'destructive' as const,
				},
			]
		: []

	return (
		<CampaignCard
			campaign={campaign}
			menuItems={menuItems}
			onClick={onClick ? () => onClick(campaign.id) : undefined}
		/>
	)
}
